// features/posts/postUtils.js

export function formatPostDate(dateString, timezone) {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  // If timezone missing, fall back to a reasonable display
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Date part (e.g. 27-Sep-2025)
  const formattedDate = date
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: tz,
    })
    .replace(/ /g, '-');

  // Time part (e.g. 07:30 AM)
  const formattedTime = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: tz,
  });

  // Timezone abbreviation (e.g. PDT)
  const timeZoneAbbrev = date
    .toLocaleTimeString('en-US', {
      timeZone: tz,
      timeZoneName: 'short',
    })
    .split(' ')
    .pop();

  return `${formattedDate} ${formattedTime} (${timeZoneAbbrev})`;
}

export function getMediaPreview(media) {
  if (!media) return '';

  if (media.content_type?.startsWith('image')) {
    return media.thumbnail_url || media.webp_url || media.media_url || media.url;
  }

  if (media.content_type?.startsWith('video')) {
    return media.poster_url || media.media_url || media.url;
  }

  return media.media_url || media.url || '';
}

// Author/moment helpers
export function firstNameFromDisplayName(displayName) {
  const full = (displayName || "").trim();
  if (!full) return "";
  return full.split(/\s+/)[0] || "";
}

// AP style possessive for names ending in s: Chris' (not Chris's)
export function possessiveAP(name) {
  const n = (name || "").trim();
  if (!n) return "";
  return n.toLowerCase().endsWith("s") ? `${n}'` : `${n}'s`;
}

function capitalizeFirst(word) {
  if (!word) return "";
  return word.charAt(0).toUpperCase() + word.slice(1);
}

// Returns e.g. "Chris' moment" or "Tressa's moment"
export function momentLabelFromAuthor(authorDisplayName) {
  const full = (authorDisplayName || "").trim();
  const rawFirst = full ? full.split(/\s+/)[0] : "Author";
  const first = capitalizeFirst(rawFirst);

  const possessive = first.toLowerCase().endsWith("s")
    ? `${first}'`
    : `${first}'s`;

  return `${possessive} moment`;
}

// Pick the best available author label from a section object
export function bestAuthorName(section) {
  return (
    section?.author ||
    section?.author_name ||
    section?.author_display_name ||
    section?.author_username ||
    null
  );
}
